export enum OperationType {
  None = 0,
  Backup = 1,
  Restore = 2,
  Archive = 3,
  MarkingForDelete = 4,
  DeleteItems = 5,
  ProcessRetention = 6,
  DeleteFromStorage = 7,
  Sync = 8,
  Export = 9,
  ClearCustomer = 10,
  DeleteUser = 11,
  CalculateUsersProviderSize = 12,
  Test = 255
}
